/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/lib/wait-for-gsap.js"
/*!*************************************!*\
  !*** ./src/js/lib/wait-for-gsap.js ***!
  \*************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   waitForGsap: () => (/* binding */ waitForGsap)
/* harmony export */ });
/**
 * Wait until vendor-gsap.js has exposed window.gsap + ScrollToPlugin.
 * @param {number} [maxAttempts=100]
 * @returns {Promise<boolean>}
 */
function waitForGsap() {
  var maxAttempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  return new Promise(function (resolve) {
    var attempts = 0;
    var _check = function check() {
      if (window.gsap && window.ScrollToPlugin) {
        resolve(true);
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        resolve(false);
        return;
      }
      setTimeout(_check, 50);
    };
    _check();
  });
}

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	const __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		const cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		const module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			const e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter/value functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			if(Array.isArray(definition)) {
/******/ 				var i = 0;
/******/ 				while(i < definition.length) {
/******/ 					var key = definition[i++];
/******/ 					var binding = definition[i++];
/******/ 					if(!__webpack_require__.o(exports, key)) {
/******/ 						if(binding === 0) {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, value: definition[i++] });
/******/ 						} else {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, get: binding });
/******/ 						}
/******/ 					} else if(binding === 0) { i++; }
/******/ 				}
/******/ 			} else {
/******/ 				for(var key in definition) {
/******/ 					if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 						Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
let __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*************************************!*\
  !*** ./src/js/zone3-add-to-cart.js ***!
  \*************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initAddToCart: () => (/* binding */ initAddToCart)
/* harmony export */ });
/* harmony import */ var _lib_wait_for_gsap_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/wait-for-gsap.js */ "./src/js/lib/wait-for-gsap.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Zone3 Add to Cart Bar
 * Custom fixed add-to-cart bar with dropdown variant selectors
 * Shows when main add-to-cart button scrolls out of view
 */
var Zone3AddToCart = /*#__PURE__*/function () {
  function Zone3AddToCart() {
    _classCallCheck(this, Zone3AddToCart);
    this.container = document.getElementById('zone3-add-to-cart');
    if (!this.container) return;
    this.variants = this.loadVariants();
    this.selectedOptions = this.getInitialSelectedOptions();
    this.mainAddToCartButton = null;
    this.previousSibling = null;
    this.mainButtonObserver = null;
    this.sectionObserver = null;
    this.init();
  }
  return _createClass(Zone3AddToCart, [{
    key: "loadVariants",
    value: function loadVariants() {
      var script = document.getElementById('zone3-product-variants');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.error('Failed to parse variants', e);
        return [];
      }
    }
  }, {
    key: "getInitialSelectedOptions",
    value: function getInitialSelectedOptions() {
      var options = {};
      this.container.querySelectorAll('.zone3-variant-dropdown').forEach(function (dropdown) {
        var _dropdown$querySelect;
        var index = dropdown.dataset.optionIndex;
        var value = (_dropdown$querySelect = dropdown.querySelector('[data-selected-value]')) === null || _dropdown$querySelect === void 0 || (_dropdown$querySelect = _dropdown$querySelect.textContent) === null || _dropdown$querySelect === void 0 ? void 0 : _dropdown$querySelect.trim();
        if (value) {
          options[index] = value;
        }
      });
      return options;
    }
  }, {
    key: "init",
    value: function init() {
      this.bindDropdowns();
      this.bindOutsideClick();
      this.bindFormSubmit();
      this.listenForMainPickerChanges();
      this.setupVisibilityObserver();

      // Update option availability on init
      this.updateOptionAvailability();
    }

    /**
     * Sets up Intersection Observer to show/hide the sticky bar
     * based on main add-to-cart button visibility
     */
  }, {
    key: "setupVisibilityObserver",
    value: function setupVisibilityObserver() {
      var _this$container$close,
        _this = this;
      // Find the main add-to-cart button (not the one in this bar)
      this.mainAddToCartButton = document.querySelector('.buy-buttons-block .add-to-cart-button, product-form-component .add-to-cart-button');

      // Get the previous sibling section for bottom boundary
      this.previousSibling = (_this$container$close = this.container.closest('.shopify-section')) === null || _this$container$close === void 0 ? void 0 : _this$container$close.previousElementSibling;
      if (!this.mainAddToCartButton) {
        // If no main button found, keep the bar hidden
        return;
      }

      // Observer for the main add-to-cart button
      // Shows sticky bar when main button scrolls out of view
      this.mainButtonObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Button is visible = hide sticky bar
          // Button is not visible = check if we should show sticky bar
          if (entry.isIntersecting) {
            _this.hideBar();
          } else {
            // Only show if button is above viewport (user scrolled past it)
            var rect = entry.boundingClientRect;
            if (rect.bottom < 0) {
              _this.showBar();
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });
      this.mainButtonObserver.observe(this.mainAddToCartButton);

      // Observer for when the sticky bar reaches its natural position
      // (below its previous sibling section)
      if (this.previousSibling) {
        this.sectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // When the previous sibling is visible at the bottom of viewport,
            // check if we should switch to static positioning
            _this.updatePositioning();
          });
        }, {
          threshold: [0, 0.1, 0.5, 1],
          rootMargin: '0px'
        });
        this.sectionObserver.observe(this.previousSibling);
      }

      // Also listen to scroll for more precise positioning updates
      var scrollTimeout;
      window.addEventListener('scroll', function () {
        if (scrollTimeout) {
          cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = requestAnimationFrame(function () {
          _this.updatePositioning();
        });
      }, {
        passive: true
      });
    }

    /**
     * Shows the sticky bar (fixed to bottom)
     */
  }, {
    key: "showBar",
    value: function showBar() {
      if (!this.container.classList.contains('is-static')) {
        this.container.classList.add('is-visible');
      }
    }

    /**
     * Hides the sticky bar
     */
  }, {
    key: "hideBar",
    value: function hideBar() {
      this.container.classList.remove('is-visible');
      this.container.classList.remove('is-static');
    }

    /**
     * Updates positioning between fixed and static based on scroll position
     */
  }, {
    key: "updatePositioning",
    value: function updatePositioning() {
      if (!this.previousSibling || !this.mainAddToCartButton) return;
      var mainButtonRect = this.mainAddToCartButton.getBoundingClientRect();
      var prevSiblingRect = this.previousSibling.getBoundingClientRect();
      var containerHeight = this.container.offsetHeight;
      var viewportHeight = window.innerHeight;

      // If main button is visible, hide the bar
      if (mainButtonRect.bottom > 0 && mainButtonRect.top < viewportHeight) {
        this.hideBar();
        return;
      }

      // If main button is above viewport (scrolled past)
      if (mainButtonRect.bottom < 0) {
        // Check if the previous sibling's bottom is above where the fixed bar would be
        // If so, switch to static positioning
        var fixedBarTop = viewportHeight - containerHeight;
        if (prevSiblingRect.bottom <= fixedBarTop) {
          // Previous sibling is above the fixed bar position
          // Switch to static so the bar follows the content
          this.container.classList.remove('is-visible');
          this.container.classList.add('is-static');
        } else {
          // Previous sibling is still below fixed bar position
          // Keep fixed positioning
          this.container.classList.remove('is-static');
          this.container.classList.add('is-visible');
        }
      }
    }
  }, {
    key: "bindDropdowns",
    value: function bindDropdowns() {
      var _this2 = this;
      this.container.querySelectorAll('.zone3-variant-dropdown').forEach(function (dropdown) {
        var trigger = dropdown.querySelector('.zone3-variant-dropdown__trigger');
        var options = dropdown.querySelectorAll('.zone3-variant-dropdown__option');

        // Toggle dropdown on trigger click
        trigger === null || trigger === void 0 || trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this2.toggleDropdown(dropdown);
        });

        // Handle option selection
        options.forEach(function (option) {
          option.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this2.selectOption(dropdown, option);
          });
        });
      });
    }
  }, {
    key: "bindOutsideClick",
    value: function bindOutsideClick() {
      var _this3 = this;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.zone3-variant-dropdown')) {
          _this3.closeAllDropdowns();
        }
      });
    }

    /**
     * Get cart section IDs that need to be re-rendered
     */
  }, {
    key: "getCartSectionIds",
    value: function getCartSectionIds() {
      var sectionIds = [];

      // Get section IDs from cart-items-component elements
      document.querySelectorAll('cart-items-component').forEach(function (item) {
        var _item$dataset;
        if ((_item$dataset = item.dataset) !== null && _item$dataset !== void 0 && _item$dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      // Also check for cart-drawer section
      var cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer]');
      if (cartDrawer) {
        var section = cartDrawer.closest('.shopify-section');
        if (section !== null && section !== void 0 && section.id) {
          var sectionId = section.id.replace('shopify-section-', '');
          if (!sectionIds.includes(sectionId)) {
            sectionIds.push(sectionId);
          }
        }
      }
      return sectionIds;
    }
  }, {
    key: "bindFormSubmit",
    value: function bindFormSubmit() {
      var _this4 = this;
      var form = this.container.querySelector('.zone3-add-to-cart__form');
      form === null || form === void 0 || form.addEventListener('submit', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
          var _form$querySelector;
          var button, variantId, originalText, sectionIds, formData, response, data, event, errorMessage, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                e.preventDefault();
                button = form.querySelector('[data-add-to-cart-btn]');
                variantId = (_form$querySelector = form.querySelector('[data-variant-id-input]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value;
                if (!(!variantId || button !== null && button !== void 0 && button.disabled)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                // Disable button and show loading state
                originalText = button.textContent;
                button.disabled = true;
                button.textContent = 'Adding...';
                _context.p = 2;
                // Get sections that need to be updated
                sectionIds = _this4.getCartSectionIds(); // Build form data
                formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', '1');

                // Add sections to request
                if (sectionIds.length > 0) {
                  formData.append('sections', sectionIds.join(','));
                  formData.append('sections_url', window.location.pathname);
                }
                _context.n = 3;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData
                });
              case 3:
                response = _context.v;
                _context.n = 4;
                return response.json();
              case 4:
                data = _context.v;
                if (!(response.ok && !data.status)) {
                  _context.n = 5;
                  break;
                }
                button.textContent = 'Added!';

                // Dispatch cart update event with sections data for cart drawer
                event = new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: data,
                    sourceId: 'zone3-add-to-cart',
                    data: {
                      source: 'zone3-add-to-cart',
                      itemCount: 1,
                      variantId: variantId,
                      sections: data.sections || {}
                    }
                  }
                });
                document.dispatchEvent(event);

                // Reset button after delay
                setTimeout(function () {
                  button.textContent = originalText;
                  button.disabled = false;
                }, 1500);
                _context.n = 6;
                break;
              case 5:
                // Handle error response
                errorMessage = data.message || data.description || 'Failed to add to cart';
                throw new Error(errorMessage);
              case 6:
                _context.n = 8;
                break;
              case 7:
                _context.p = 7;
                _t = _context.v;
                console.error('Add to cart error:', _t);
                button.textContent = 'Error';
                setTimeout(function () {
                  button.textContent = originalText;
                  button.disabled = false;
                }, 1500);
              case 8:
                return _context.a(2);
            }
          }, _callee, null, [[2, 7]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "listenForMainPickerChanges",
    value: function listenForMainPickerChanges() {
      var _this5 = this;
      // Listen for variant:update events from the main product picker
      document.addEventListener('variant:update', function (e) {
        var _e$detail;
        var variant = (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.resource;
        if (!variant) return;

        // Update our UI to match
        _this5.updateFromVariant(variant);
      });

      // Also listen for variant:selected for immediate feedback
      document.addEventListener('variant:selected', function (e) {
        var _e$detail2;
        var optionValueId = (_e$detail2 = e.detail) === null || _e$detail2 === void 0 || (_e$detail2 = _e$detail2.resource) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.id;
        if (!optionValueId) return;

        // Find the main picker and get the current selected option value
        var mainPicker = document.querySelector('variant-picker:not(.zone3-add-to-cart variant-picker)');
        if (!mainPicker) return;
        var selectedInput = mainPicker.querySelector("input[data-option-value-id=\"".concat(optionValueId, "\"]"));
        if (!selectedInput) return;
        var value = selectedInput.value;
        var fieldset = selectedInput.closest('fieldset');
        var fieldsetIndex = fieldset === null || fieldset === void 0 ? void 0 : fieldset.dataset.fieldsetIndex;
        if (value && fieldsetIndex !== undefined) {
          _this5.updateOptionDisplay(parseInt(fieldsetIndex), value);
        }
      });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(dropdown) {
      var isOpen = dropdown.classList.contains('is-open');

      // Close all dropdowns first
      this.closeAllDropdowns();

      // Open this one if it wasn't already open
      if (!isOpen) {
        var _dropdown$querySelect2;
        dropdown.classList.add('is-open');
        (_dropdown$querySelect2 = dropdown.querySelector('.zone3-variant-dropdown__trigger')) === null || _dropdown$querySelect2 === void 0 || _dropdown$querySelect2.setAttribute('aria-expanded', 'true');
      }
    }
  }, {
    key: "closeAllDropdowns",
    value: function closeAllDropdowns() {
      this.container.querySelectorAll('.zone3-variant-dropdown.is-open').forEach(function (dropdown) {
        var _dropdown$querySelect3;
        dropdown.classList.remove('is-open');
        (_dropdown$querySelect3 = dropdown.querySelector('.zone3-variant-dropdown__trigger')) === null || _dropdown$querySelect3 === void 0 || _dropdown$querySelect3.setAttribute('aria-expanded', 'false');
      });
    }
  }, {
    key: "selectOption",
    value: function selectOption(dropdown, option) {
      var optionIndex = parseInt(dropdown.dataset.optionIndex);
      var value = option.dataset.optionValue;

      // Update selected state
      dropdown.querySelectorAll('.zone3-variant-dropdown__option').forEach(function (opt) {
        opt.classList.remove('is-selected');
        opt.removeAttribute('aria-current');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-current', 'true');

      // Update display value
      this.updateOptionDisplay(optionIndex, value);

      // Close dropdown
      this.closeAllDropdowns();

      // Update selected options
      this.selectedOptions[optionIndex] = value;

      // Find matching variant
      var variant = this.findVariant();
      if (variant) {
        this.updateVariantUI(variant);
        this.syncToMainPicker(variant);
      }
    }
  }, {
    key: "updateOptionDisplay",
    value: function updateOptionDisplay(optionIndex, value) {
      var dropdown = this.container.querySelector("[data-option-index=\"".concat(optionIndex, "\"]"));
      var valueDisplay = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('[data-selected-value]');
      if (valueDisplay) {
        valueDisplay.textContent = value;
      }

      // Update selected option tracking
      this.selectedOptions[optionIndex] = value;

      // Update selected state in dropdown
      dropdown === null || dropdown === void 0 || dropdown.querySelectorAll('.zone3-variant-dropdown__option').forEach(function (opt) {
        var isSelected = opt.dataset.optionValue === value;
        opt.classList.toggle('is-selected', isSelected);
        if (isSelected) {
          opt.setAttribute('aria-current', 'true');
        } else {
          opt.removeAttribute('aria-current');
        }
      });
    }
  }, {
    key: "findVariant",
    value: function findVariant() {
      var selectedValues = Object.values(this.selectedOptions);
      return this.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedValues[index];
        });
      });
    }
  }, {
    key: "updateVariantUI",
    value: function updateVariantUI(variant) {
      // Update price
      var priceEl = this.container.querySelector('[data-price]');
      if (priceEl) {
        priceEl.textContent = this.formatMoney(variant.price);
      }

      // Update compare price
      var comparePriceEl = this.container.querySelector('[data-compare-price]');
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update form variant ID
      var variantInput = this.container.querySelector('[data-variant-id-input]');
      if (variantInput) {
        variantInput.value = variant.id;
      }

      // Update button state
      var button = this.container.querySelector('[data-add-to-cart-btn]');
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update container data attribute
      this.container.dataset.currentVariantId = variant.id;

      // Update option availability
      this.updateOptionAvailability();
    }

    /**
     * Updates which options are available based on current selections
     * An option is available if there's at least one variant with that option value
     * that's in stock (considering other selected options)
     */
  }, {
    key: "updateOptionAvailability",
    value: function updateOptionAvailability() {
      var _this6 = this;
      var dropdowns = this.container.querySelectorAll('.zone3-variant-dropdown');
      dropdowns.forEach(function (dropdown, dropdownIndex) {
        var options = dropdown.querySelectorAll('.zone3-variant-dropdown__option');
        options.forEach(function (option) {
          var optionValue = option.dataset.optionValue;

          // Check if any variant with this option value is available
          var isAvailable = _this6.variants.some(function (variant) {
            // Check if this variant has the option value at this position
            if (variant.options[dropdownIndex] !== optionValue) return false;

            // Check if this variant matches all other currently selected options
            var matchesOtherSelections = Object.entries(_this6.selectedOptions).every(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                index = _ref3[0],
                value = _ref3[1];
              // Skip the current dropdown we're checking
              if (parseInt(index) === dropdownIndex) return true;
              // Check if this variant matches the selected value for other options
              return variant.options[parseInt(index)] === value;
            });

            // Return true if variant matches and is available
            return matchesOtherSelections && variant.available;
          });

          // Update availability state
          option.dataset.available = isAvailable.toString();
          option.classList.toggle('is-unavailable', !isAvailable);
        });
      });
    }
  }, {
    key: "updateFromVariant",
    value: function updateFromVariant(variant) {
      var _this7 = this;
      // Update option displays based on variant
      if (variant.options) {
        variant.options.forEach(function (value, index) {
          _this7.updateOptionDisplay(index, value);
        });
      }

      // Update price and button
      this.updateVariantUI(variant);
    }
  }, {
    key: "syncToMainPicker",
    value: function syncToMainPicker(variant) {
      // Find the main product picker
      var mainPickers = document.querySelectorAll('variant-picker');
      mainPickers.forEach(function (picker) {
        // Skip if it's in our section (shouldn't be, but just in case)
        if (picker.closest('.zone3-add-to-cart')) return;

        // Find matching variant option inputs and check them
        variant.options.forEach(function (value, index) {
          var fieldset = picker.querySelector("[data-fieldset-index=\"".concat(index, "\"]"));
          if (!fieldset) return;
          var input = fieldset.querySelector("input[value=\"".concat(value, "\"]"));
          if (input && !input.checked) {
            // Uncheck all in fieldset
            fieldset.querySelectorAll('input').forEach(function (inp) {
              inp.checked = false;
              inp.dataset.currentChecked = 'false';
            });

            // Check the matching one
            input.checked = true;
            input.dataset.currentChecked = 'true';

            // Trigger change to update the picker
            input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }
        });
      });
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(cents) {
      // Simple money formatter - adjust based on your store's currency settings
      var amount = (cents / 100).toFixed(2);
      return "\xA3".concat(amount);
    }
  }]);
}();

function initAddToCart() {
  return _initAddToCart.apply(this, arguments);
}
function _initAddToCart() {
  _initAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var anchorScroll, ready, gsap;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          new Zone3AddToCart();
          anchorScroll = document.querySelectorAll('[data-anchor]');
          if (!(anchorScroll.length === 0)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, true);
        case 1:
          _context2.n = 2;
          return (0,_lib_wait_for_gsap_js__WEBPACK_IMPORTED_MODULE_0__.waitForGsap)();
        case 2:
          ready = _context2.v;
          if (ready) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, true);
        case 3:
          gsap = window.gsap;
          anchorScroll.forEach(function (scrollLink) {
            scrollLink.addEventListener('click', function (e) {
              e.preventDefault();
              var anchor = this.dataset.anchor;
              gsap.to(window, {
                duration: 0.5,
                scrollTo: '#' + anchor,
                ease: 'power2.inOut'
              });
            });
          });
          return _context2.a(2, true);
      }
    }, _callee2);
  }));
  return _initAddToCart.apply(this, arguments);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddToCart);
} else {
  initAddToCart();
}
})();

/******/ })()
;
//# sourceMappingURL=zone3-add-to-cart.js.map